import Dialog from "@material-ui/core/Dialog";
import dynamic from "next/dynamic";
import React from "react";

import { FormikDialogContentProps } from "./FormikDialogContent";
import { useDialogStyles } from "./dialogStyles";

const FormikDialogContent = dynamic(
  () => import("./FormikDialogContent").then((mod) => mod.FormikDialogContent),
  {
    ssr: false,
  },
);

type FormikDialogProps<T> = { open?: boolean } & FormikDialogContentProps<T>;

export function FormikDialog<T>(props: FormikDialogProps<T>) {
  const {
    onClose,
    open,
    initialValues,
    onSubmit,
    title,
    message,
    validationSchema,
    enableReinitialize,
    unsavedMessage,
    confirmButtonLabel,
    showUnsavedAlert,
  } = props;
  const classes = useDialogStyles();

  if (!initialValues) return null;
  return (
    <Dialog
      onClick={(e) => e.stopPropagation()}
      open={open}
      classes={{
        paper: classes.paper,
      }}
      scroll="paper"
      maxWidth="sm"
    >
      <FormikDialogContent
        initialValues={initialValues}
        onSubmit={onSubmit}
        title={title}
        message={message}
        validationSchema={validationSchema}
        enableReinitialize={enableReinitialize}
        unsavedMessage={unsavedMessage}
        confirmButtonLabel={confirmButtonLabel}
        showUnsavedAlert={showUnsavedAlert}
        onClose={onClose}
      />
    </Dialog>
  );
}
